import { CheckboxCard } from "@/shared/ui/FormCheckboxCard";
import type { DocumentPrintSignatureOptions } from "@/shared/lib/document-print-signature-options";
import type { DocumentDTO } from "../../domain/contracts";

type DocumentPrintSignatureOptionsPanelProps = {
  documentType: DocumentDTO["documentType"];
  value: DocumentPrintSignatureOptions;
  onChange: (value: DocumentPrintSignatureOptions) => void;
  className?: string;
};

export function DocumentPrintSignatureOptionsPanel({
  documentType: _documentType,
  value,
  onChange,
  className,
}: DocumentPrintSignatureOptionsPanelProps) {
  return (
    <div className={className}>
      <p className="mb-1 font-medium text-sm">ການພິມ — ລາຍເຊັນ / ຕາປະທັບ</p>
      <p className="mb-2 text-muted-foreground text-xs">
        ເລືອກໃສ່ຮູບລ່ວງໜ້າ — ຫົວຂໍ້ ແລະ ຊ່ອງວ່າງຍັງຄົງໄວ້ໃຫ້ປະທັບ/ເຊັນເອງ
      </p>
      <div className="grid gap-2 sm:grid-cols-2">
        <CheckboxCard
          checked={value.includeStudioStamp}
          onCheckedChange={(checked) =>
            onChange({ ...value, includeStudioStamp: checked })
          }
          label="ຮູບຕາປະທັບ Studio"
          description="ບໍ່ເລືອກ = ຊ່ອງວ່າງໃຫ້ປະທັບເອງ"
        />
        <CheckboxCard
          checked={value.includeStudioSignature}
          onCheckedChange={(checked) =>
            onChange({ ...value, includeStudioSignature: checked })
          }
          label="ຮູບລາຍເຊັນ Studio"
          description="ບໍ່ເລືອກ = ຊ່ອງວ່າງໃຫ້ເຊັນເອງ"
        />
      </div>
    </div>
  );
}
